export default {"src":"/_next/static/media/whiteStar.02f34ae9.svg","height":22,"width":21,"blurWidth":0,"blurHeight":0};